import { render } from "./PatientsDatatableFormTeeth.vue?vue&type=template&id=9cf7655e"
import script from "./PatientsDatatableFormTeeth.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableFormTeeth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__